/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Terms_TitleInputs */

const en_meta_terms_title = /** @type {(inputs: Meta_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service | Lindevo`)
};

const lv_meta_terms_title = /** @type {(inputs: Meta_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lietošanas noteikumi | Lindevo`)
};

/**
* | output |
* | --- |
* | "Terms of Service \| Lindevo" |
*
* @param {Meta_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_terms_title = /** @type {((inputs?: Meta_Terms_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Terms_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_terms_title(inputs)
	return en_meta_terms_title(inputs)
});